import { ChecksumAddress } from "@silo/types";
import { FC, ReactNode } from "react";
import { usePositionsPanelContext } from "../position-panel-context";
import { asFullUSD, convertCurrency, mapNullable } from "@silo/utils";
import { twMerge } from "tailwind-merge";
import { EmptyText } from "../../empty-text";

interface AmountInUSDProps {
  assetAddress: ChecksumAddress;
  decimals: number;
  amount: bigint;
  loadingSlot?: ReactNode;
  className?: string;
}

export const AmountInUSD: FC<AmountInUSDProps> = ({
  assetAddress,
  decimals,
  amount,
  loadingSlot = <EmptyText />,
  className,
}) => {
  const { useAssetPriceInUSD } = usePositionsPanelContext();
  const priceInUSD = useAssetPriceInUSD(assetAddress);

  const amountInUSD = mapNullable(priceInUSD, (priceInUSD) =>
    convertCurrency({ decimals, value: amount }, priceInUSD)
  );

  return (
    <span className={twMerge(className)}>
      {amountInUSD ? asFullUSD(amountInUSD) : loadingSlot}
    </span>
  );
};
